import React from 'react'
import PropTypes from 'prop-types'

import PreviewTop from './modules/header/PreviewTop'
import PreviewHeader from './modules/header/PreviewHeader'
import BillItemsPreview from 'billing/common/modules/items/BillItemsPreview'
import NotesPreview from 'billing/common/modules/notes/NotesPreview'
import PhotosPreview from './modules/photos/PhotosPreview'

export default class InvoicePreview extends React.Component {

  static propTypes = {
    invoiceEditor: PropTypes.object.isRequired,
    onBackClicked: PropTypes.func.isRequired
  }

  render() {
    return (
      <div style={styles.container}>
        <PreviewTop invoiceEditor={this.props.invoiceEditor} />
        <PreviewHeader invoiceEditor={this.props.invoiceEditor} />
        <BillItemsPreview billEditor={this.props.invoiceEditor} hasPayments={true} />
        <NotesPreview billEditor={this.props.invoiceEditor} />
        <PhotosPreview invoiceEditor={this.props.invoiceEditor} />
      </div>
    )
  }

}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column'
  }
}



// WEBPACK FOOTER //
// ./src/billing/invoices/InvoicePreview.js